import { parametric, pathSubscription, subscription } from 'nike-re-framejs';
import { List, Map } from 'immutable';
import { countPicksAvailableToClose } from './handlers';

const cashinClosing$ = pathSubscription(['ticketus', 'closing'], Map());

export const icCashinClosingModeActive = (closing, ticketId) => {
    const eventualTotalsWin = closing.getIn([ticketId, 'eventualTotals', 'win']);
    if (isNaN(eventualTotalsWin)) {
        return ticketId && closing.getIn(['ticketId']) === ticketId;
    }
    return ticketId && closing.getIn(['ticketId']) === ticketId && eventualTotalsWin > 0;
};

export const cashinClosingModeActive$ = parametric(ticketId =>
    subscription(closing => {
        return icCashinClosingModeActive(closing, ticketId);
    }, cashinClosing$)
);

export const cashinClosingModeAnyActive$ = pathSubscription(['ticketus', 'closing', 'ticketId'], false);

export const newTransactionStarted$ = pathSubscription(['ticketus', 'closing', 'transaction-started']);

export const cashinOddsChosenPicks$ = ticketId =>
    pathSubscription(['ticketus', 'closing', ticketId, 'chosenPicks'], List());

export const cashinClosingChosenDisabledPicks$ = ticketId =>
    pathSubscription(['ticketus', 'closing', ticketId, 'disabledChosenPicks'], List());

export const cashinIsLoading$ = ticketId => pathSubscription(['ticketus', 'closing', ticketId, 'isLoading']);

export const cashinOfferCurrent$ = () => pathSubscription(['ticketus', 'cashin', 'current-opened']);
export const evalEventualTotals$ = ticketId => pathSubscription(['ticketus', 'closing', ticketId, 'eventualTotals']);
export const evalEventualTotalsWin$ = ticketId =>
    pathSubscription(['ticketus', 'closing', ticketId, 'eventualTotals', 'win']);
export const evalEventualTotalsBonusGameId$ = ticketId =>
    pathSubscription(['ticketus', 'closing', ticketId, 'eventualTotals', 'bonusGameId']);
export const isCashinClosingCheckboxChecked = parametric((ticketId, betId) =>
    subscription(db => {
        const closingByTicketId = db.getIn(['ticketus', 'closing', ticketId]);
        if (!closingByTicketId) return false;
        const disabledPicks = closingByTicketId.getIn(['disabledChosenPicks'], List());
        const chosenPicks = closingByTicketId.getIn(['chosenPicks'], List());
        return (
            disabledPicks.some(bet => bet.get('betId') === betId) || chosenPicks.some(bet => bet.get('betId') === betId)
        );
    })
);

export const allPicksChosen$ = parametric(ticketId =>
    subscription(db => {
        const cashinOffer = db.getIn(['ticketus', 'cashin', 'tickets', ticketId]);
        const chosenPicks = db.getIn(['ticketus', 'closing', ticketId, 'chosenPicks'], List());
        if (!cashinOffer || chosenPicks.size === 0) return false;
        return countPicksAvailableToClose(cashinOffer.get('picks')).size === chosenPicks.size;
    })
);
